import type { en } from './en.js';

export const ru: typeof en = {
  app: {
    name: 'BN-games',
    tagline: 'Классические настольные игры в браузере. Бесплатно, без установки, регистрация не обязательна.',
  },
  seo: {
    title: 'Настольные игры онлайн бесплатно — шахматы, нарды, шашки, домино, маджонг и судоку | BN-games',
    description: 'Классические настольные игры в браузере — шахматы, длинные нарды, шашки, домино, судоку и маджонг. Бесплатно, без установки, регистрация не обязательна.',
    social: 'Классические настольные игры в браузере — шахматы, длинные нарды, шашки, домино, судоку и маджонг.',
  },
  notFound: {
    title: 'Страница не найдена — BN-games',
    heading: 'Страница не найдена',
    body: 'Такой страницы нет или она переехала. Выберите игру ниже или перейдите на главную.',
    home: 'На главную',
  },
  common: {
    play: 'Играть',
  },
  auth: {
    signIn: 'Войти',
    signOut: 'Выйти',
    google: 'Google',
    github: 'GitHub',
    completeProfile: 'Заполните профиль →',
    profile: 'Профиль',
  },
  nav: {
    games: 'Игры',
    about: 'О проекте',
    changelog: 'История изменений',
  },
  hero: {
    title: 'Классические настольные игры прямо в браузере',
    subtitle:
      'Сыграйте с тем, кто рядом, с кем-нибудь на другом конце света или с ботом. Просто откройте страницу — ничего устанавливать не нужно, регистрироваться тоже.',
    social: 'Добавляйте друзей, смотрите, кто в сети, и зовите их в игру одним нажатием.',
  },
  games: {
    sectionTitle: 'Игры',
    rulesLink: 'Правила',
    backgammon: {
      name: 'Длинные нарды',
      description:
        'Нарды по длинной дорожке — кавказско-балканский вариант. За одним устройством, онлайн или против бота.',
      cta: 'Играть в длинные нарды',
      thumbAlt: 'Скриншот игры в длинные нарды',
    },
    checkers: {
      name: 'Шашки',
      description:
        'Два варианта — Советские шашки (летающие дамки, превращение по ходу взятия) и Английские шашки. За одним устройством, онлайн или против бота с четырьмя уровнями сложности.',
      cta: 'Играть в шашки',
      thumbAlt: 'Скриншот игры в шашки',
    },
    domino: {
      name: 'Домино',
      description:
        'Три игры — «Козёл», «Телефон» и «Все пятёрки» (Маггинс). От 2 до 4 игроков, каждый сам за себя или пара на пару. За одним устройством, онлайн или против бота с тремя уровнями сложности.',
      cta: 'Играть в домино',
      thumbAlt: 'Домино — стартовая раздача, цепочка ветвится от центрального дубля',
    },
    chess: {
      name: 'Шахматы',
      newBadge: 'Новинка',
      description:
        'Классические шахматы по правилам ФИДЕ. Играйте с ботом четырёх уровней, с другом за одним устройством или онлайн по коду комнаты — с часами или без. Каждая партия сохраняется, её можно пересмотреть по ходам и выгрузить в PGN.',
      cta: 'Играть в шахматы',
      thumbAlt: 'Шахматы — начальная позиция на деревянной доске',
    },
    mahjong: {
      name: 'Маджонг',
      description:
        'Сначала научитесь, потом играйте по-настоящему. Шесть уроков и тренер, объясняющий каждый совет по сбросу, упрощённый обучающий вариант и полные китайские классические правила с каном и подсчётом очков, а также сетевые столы до четырёх игроков — свободные места займут боты.',
      cta: 'Играть в маджонг',
      thumbAlt: 'Маджонг — стол на четырёх игроков, плитки разложены вокруг центрального сброса',
    },
    sudoku: {
      name: 'Судоку',
      description:
        'Один тап — и играешь. Удобно на телефоне даже на маленьком экране, и каждая партия — новая уникальная головоломка. Три уровня сложности, карандашные пометки, подсказки с названием нужного приёма и ссылка, которой можно поделиться с другом.',
      cta: 'Играть в судоку',
      thumbAlt: 'Судоку — сетка 9×9 в процессе решения с карандашными пометками',
    },
  },
  about: {
    sectionTitle: 'О проекте',
    body: 'Небольшая подборка классических настольных игр для браузера. Всё работает на вашем устройстве — открыли страницу и играете. Онлайн-комнаты обслуживаются одним общим сервером; больше со страницы ничего не уходит. Вход в аккаунт — по желанию: он даёт имя, которое видят соперники, список друзей со статусом «в сети», приглашения, которые доходят до друзей на любой странице, и историю партий на всех ваших устройствах. Без трекинга, без рекламы. Бесплатно — и таким останется.',
  },
  changelog: {
    sectionTitle: 'История изменений',
    showAll: 'Вся история изменений →',
    entries: {
      chessLaunch:
        'Появились шахматы — классические правила ФИДЕ: против бота четырёх уровней, с другом за одним устройством или онлайн по коду комнаты, с часами (пуля, блиц или рапид) или без, с предложением ничьей. Каждая партия сохраняется: её можно пересмотреть по ходам, выгрузить в PGN или FEN — или вставить позицию и доиграть с неё. Если вы вошли в аккаунт, онлайн-партии синхронизируются с ним. Также исправлено: комната домино или маджонга могла закрыться через час после начала партии, которая ещё шла.',
      kozyolAndOnlineFixes:
        'В домино появился настоящий «Козёл» — дворовая игра в линию, где проигравший записывает очки на руках, а набравший 101 становится козлом, — с ботами, игрой онлайн и повторами партий. Игра, которую мы раньше называли «Козлом», теперь называется правильно — «Телефон». В онлайн-играх вернувшийся в комнату до начала партии больше не видит пустой экран, автоматический Маггинс включён по умолчанию, а предложение добавить в друзья не показывается тем, кто уже в друзьях.',
      publicLaunch:
        'Версия 1.0 — BN-games официально открыт для всех. У каждой игры появилась своя страница на русском и страница с правилами на обоих языках, эта страница загружается быстрее благодаря облегчённым скриншотам, а в меню игр больше не обрезается нижняя кнопка.',
      invitesEverywhere:
        'Приглашения в игру теперь приходят мгновенно на любой странице — в меню, на этом сайте и маленьким значком прямо во время партии, — а в списке друзей вы отображаетесь в сети, пока открыта хотя бы одна ваша вкладка.',
      inviteAndPresenceFixes:
        'Принятое приглашение теперь сразу открывает комнату без перезагрузки страницы, а друзья посреди партии отображаются как «в игре», а не «не в сети».',
      realtimeOnCloudflare:
        'Онлайн-игры переехали на новый сервер реального времени: текущая партия теперь переживает обновления сервера, а не обрывается, комнаты дожидаются переподключения всех игроков, а друзья видят, когда вы были в сети в последний раз.',
      signedInPlayerSurfaces:
        'На странице профиля появилась прямая ссылка на «Друзей», соперники видят выбранное вами имя (а не то, что прислал сервис входа), а история онлайн-партий в длинных нардах, шашках и домино теперь хранится в разделе «Ваш аккаунт» — синхронизированно, а не только в этом браузере.',
      accountsAndIdentities:
        'Управление аккаунтом: привязывайте Google, GitHub и Discord к одному аккаунту, смотрите все устройства, на которых вы вошли, и при желании можете полностью удалить аккаунт.',
      roomCodesSixChar:
        'Коды онлайн-комнат теперь состоят из шести символов вместо четырёх и генерируются более защищённым способом.',
      resumeParity:
        'Шашки, домино и маджонг теперь так же надёжно возвращают в онлайн-партию, как всегда умели длинные нарды: повторное открытие своей же ссылки на комнату больше не сообщает, что комната заполнена, а ссылки-приглашения в маджонге наконец работают.',
      onlineIdentityFixes:
        'Исправлены две незаметные ошибки с онлайн-аккаунтом: если на старт онлайн-партии уходило больше минуты, вас могло посадить за стол анонимно, даже если вы вошли в аккаунт, а часть таких партий вообще не попадала в историю.',
      serverHistorySync:
        'История онлайн-партий теперь синхронизируется с аккаунтом: смотрите счёт побед и поражений и пересматривайте прошлые партии с любого устройства — в длинных нардах, шашках и домино.',
      friendsAndInvites:
        'Друзья и приглашения. Добавляйте друзей по нику, смотрите, кто сейчас онлайн, и приглашайте прямо в комнату — присутствие видно в реальном времени, а приглашение приходит мгновенно, во всех четырёх онлайн-играх.',
      dominoConnectionOverlay:
        'Домино теперь показывает, что перетаскивание костей зависло из-за сбоя соединения, а не оставляет вас гадать, в чём дело.',
      onlineReconnectFix:
        'Онлайн-комнаты стали надёжнее: ссылка на комнату или сохранённая сессия теперь сразу возвращают вас на своё место, а разрыв соединения больше не стирает сессии других комнат, в которых вы даже не участвовали.',
      landingHeaderNav:
        'В главном меню каждой игры появились вход и выход из аккаунта и ссылка на список игр — так же, как на главной странице.',
      authPolishLegalPages:
        'Исправлена нерабочая ссылка «Заполните профиль» в длинных нардах и добавлена недостающая кнопка выхода из аккаунта. Опубликованы страницы Политики конфиденциальности и Условий использования — ссылки на них теперь в подвале сайта.',
      identityInRooms:
        'В длинных нардах онлайн-соперник теперь видит ваше настоящее имя и аватар, если вы вошли в аккаунт, — это подтверждается на сервере, так что имя подделать нельзя.',
      mahjongLaunch:
        'Запуск маджонга — сначала научитесь, потом играйте по-настоящему. Шесть уроков и тренер, который объясняет каждый свой совет по сбросу, упрощённый обучающий вариант и полные китайские классические правила с каном и традиционным подсчётом очков, а также сетевые столы до четырёх игроков — свободные места займут боты. Ваши плитки не видит никто, кроме вас, стена раздаётся из того же публичного маяка случайности, что и кубики, а клавиша Escape в любой момент ставит игру на паузу.',
      optionalSignIn:
        'Необязательный вход через Google или GitHub. Один раз выберите ник и отображаемое имя — и соперники онлайн будут видеть вас по имени, а не как «Player». Это полностью по желанию: без аккаунта всё работает ровно так же.',
      dominoLastAction:
        'Домино теперь показывает, что только что произошло — кто какую кость положил и сколько очков набрал, кто взял из базара, кто пропустил ход, — и только потом сообщает, чей ход. Вид доски больше не сбрасывается, когда ходит соперник. В «Телефоне» право первого хода каждую раздачу переходит по часовой стрелке, и это описано на экране правил. На экране входа в длинных нардах, шашках и домино код комнаты теперь можно вставить сочетанием Ctrl+V.',
      afkPing:
        'Позовите соперника, который затих. В онлайн-играх рядом появляется колокольчик, если ход за ним уже какое-то время, — нажмите, и на его стороне прозвучит сигнал. И отправку, и приём можно отключить в настройках.',
      sudokuLaunch:
        'Запуск судоку — классические 9×9, в одиночку. Три уровня сложности на базе логического решателя, карандашные пометки, подсказки с названием нужного приёма, секундомер мм:сс, продолжение начатой партии и ссылка, которой можно поделиться с другом.',
      dominoBoneyardPolish:
        'Домино: чтобы взять кость из базара, теперь нужно нажать на саму стопку — отдельной кнопки «Взять» больше нет. Наведите курсор на кость в руке, чтобы увидеть, куда её можно положить. В настройках появилась опция показывать количество костей в базаре.',
      pwaInstall:
        'Каждую игру теперь можно установить. Добавьте её на главный экран или рабочий стол — и она будет открываться в собственном окне со своей иконкой, без вкладок и панели браузера.',
      verifiableRng:
        'Кубики и раздачи теперь проверяемо честные. В проверяемых комнатах каждый бросок и каждая раздача берут случайность из публичного маяка (drand), а проверка в истории позволяет вам — или кому угодно — убедиться, что прошедшая партия была честной.',
      accessibilityPass:
        'Полный заход на доступность. Во все игры можно играть с клавиатуры, скринридер озвучивает каждый ход, все четыре темы соответствуют контрасту WCAG AA, и везде учитывается настройка «меньше движения».',
      inGameOverlay:
        'Меню паузы прямо в партии — «Заново», «Выйти», «Сдаться» и вкладка настроек, доступные в любой момент по Escape или иконке шестерёнки. Если задумались на своём ходу, мягкий звук и подсвеченный возможный ход помогут вернуться. На главном меню появилась кнопка быстрого старта.',
      landingRefresh:
        'Главную страницу обновили: простой язык, отдельные адреса для языков (английский — /, русский — /ru/), карточки превью для соцсетей, переключатель языка в подвале.',
      menuOverhaul:
        'Меню причесали во всех играх. У онлайн-комнат появились коды с копированием в один клик и ссылки-приглашения; на экране входа работает вставка ссылки; раскладка аккуратно масштабируется на больших экранах и на мобильных.',
      backgammonOnlineFixes:
        'Длинные нарды онлайн: починили «зависающие» партии после перезагрузки страницы, починили смену сторон при реванше, и перенесли расчёты сильного бота в отдельный поток — игра стала плавнее.',
      dominoLaunch:
        'Запуск домино — сразу два варианта: «Все пятёрки» и «Телефон». От 2 до 4 игроков, каждый сам за себя или пара на пару. За одним устройством, онлайн и три уровня сложности бота. Полная история партий.',
      monorepoMigration: 'Длинные нарды переехали в проект BN-games к шашкам.',
      checkersLaunch:
        'Запуск шашек — за одним устройством, онлайн и четыре уровня сложности бота.',
      backgammonLaunch:
        'Запуск длинных нард — за одним устройством, онлайн и против бота. Полная история партий.',
    },
  },
  footer: {
    yearLine: '© {{year}} BN-games',
    legalNav: 'Правовая информация',
    // privacy.html / terms.html exist only in English — kept untranslated
    // here so the link text doesn't promise a Russian page that isn't there.
    privacy: 'Privacy Policy',
    terms: 'Terms of Service',
  },
  language: {
    toggleLabel: 'Язык',
    en: 'English',
    ru: 'Русский',
  },
  landing: {
    skipLink: 'Перейти к основному содержанию',
  },
  // Only the keys `@bn-games/ui-shell/social`'s invite dock reads.
  social: {
    invite: {
      message: '{{sender}} приглашает вас в {{game}}',
      moreCount_one: '+{{count}} ещё приглашение',
      moreCount_few: '+{{count}} ещё приглашения',
      moreCount_many: '+{{count}} ещё приглашений',
      moreCount_other: '+{{count}} ещё приглашений',
      accept: 'Принять',
      decline: 'Отклонить',
      acceptAria: 'Принять приглашение от {{sender}} в {{game}}',
      declineAria: 'Отклонить приглашение от {{sender}} в {{game}}',
    },
    dock: {
      pillLabel: 'От {{sender}}',
      pillAria: 'Приглашение от {{sender}} в {{game}} — показать',
      popoverLabel: 'Приглашение',
      close: 'Закрыть приглашение',
      leaveGameTitle: 'Покинуть игру?',
      leaveGameBody: 'Приглашение откроет {{game}}, а текущая партия будет прервана. В онлайн-игре ваше место какое-то время сохраняется — вы сможете вернуться.',
      leaveGameConfirm: 'Выйти и присоединиться',
      leaveGameCancel: 'Остаться',
    },
  },
};
